import { render } from "./TermsConditionsPage.vue?vue&type=template&id=1a8e25a0&scoped=true&ts=true"
import script from "./TermsConditionsPage.vue?vue&type=script&lang=ts"
export * from "./TermsConditionsPage.vue?vue&type=script&lang=ts"

import "./TermsConditionsPage.vue?vue&type=style&index=0&id=1a8e25a0&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1a8e25a0"]])

export default __exports__